import React from "react";

const toggleClasses = (active) =>
  active
    ? "bg-custom-blue text-white border-2 border-sky-400 shadow-accent"
    : "bg-violet-300/[0.15] text-brand-muted border-2 border-violet-300";

const PlatformToggle = ({ platform, onChange }) => {
  return (
    <div className="flex justify-center gap-3">
      <button
        className={`px-4 py-2 rounded-full font-semibold text-sm active:scale-95 transition-transform ${toggleClasses(
          platform === "iphone"
        )}`}
        onClick={() => onChange("iphone")}
      >
        📱 iPhone
      </button>
      <button
        className={`px-4 py-2 rounded-full font-semibold text-sm active:scale-95 transition-transform ${toggleClasses(
          platform === "android"
        )}`}
        onClick={() => onChange("android")}
      >
        🤖 Android
      </button>
    </div>
  );
};

export default PlatformToggle;
